import React, { useEffect, useState, useContext } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import { Typography } from '@mui/material';
import SubscribeModal from 'components/SubscribeModal';
import { Player } from '@lottiefiles/react-lottie-player';
import ModuleHeaderLayout from 'components/Common/Layouts/ModuleHeaderLayout';

const BiteViz: React.FC = () => {
  const bite_viz_dashboard = process.env.REACT_APP_BITE_VIZ_LINK!;
  const { cur_user } = useContext(GlobalContext);
  const [ userHasBiteViz, setUserHasBiteViz ] = useState(false);
  const [ activeSub, setActiveSub ] = useState(false);
  const [ matchedTeamWithStripe, setMatchedTeamWithStripe ] =
    useState<string>('');

  const checkForBiteViz = () => {
    if (
      cur_user.selected_team?.attributes?.tier?.includes('enterprise') ||
      cur_user.selected_team?.attributes?.tier?.includes('pro')
    ) {
      setUserHasBiteViz(true);
    }
    if (cur_user.stripe_cus_info) {
      cur_user.stripe_cus_info.map((cus: any) => {
        if (cus.name === cur_user.selected_team.name) {
          setMatchedTeamWithStripe(cus.id);
          cus.subscriptions.data.map((sub: any) => {
            if (
              sub.metadata.moduleName === 'BITE Pro' ||
              sub.metadata.moduleName === 'BITE Enterprise'
            ) {
              setActiveSub(true);
            }
          });
        }
      });
    }
  };

  useEffect(() => {
    checkForBiteViz();
  }, []);

  return (
    <ModuleHeaderLayout title='BITE VIZ' helpContent={''}>
      {activeSub && !userHasBiteViz ? (
        <div className='no-license-modal'>
          <Player
            autoplay
            loop
            src='https://lottie.host/3c23c1ad-7f71-4e3d-8f19-69154715dbdc/SdWWjCmU1J.json'
            style={{ width: '20%' }}
          ></Player>
          <Typography
            variant='h6'
            className='text-white'
            style={{
              fontSize: '20px',
              fontWeight: 700,
              lineHeight: '24px',
              letterSpacing: '0.15px',
            }}
          >
            You need an assigned license to access this module
          </Typography>
          <Typography
            variant='h6'
            style={{
              fontSize: '18px',
              fontWeight: 700,
              lineHeight: '24px',
              letterSpacing: '0.15px',
              marginTop: '20px',
              color: '#BDBEC1',
            }}
          >
            Visit Account &gt; Users &gt; to assign an available license to your
            user or contact your team admin
          </Typography>
        </div>
      ) : !userHasBiteViz ? (
        <SubscribeModal
          name='BITE Viz'
          description='Create custom reports, visuals and analytical products'
          price={25}
          curUser={cur_user}
          stripeTeam={matchedTeamWithStripe}
          activeSub={activeSub}
        />
      ) : (
        <></>
      )}
      <div className={`os-iframe${!userHasBiteViz ? '-blur' : ''}`}>
        <iframe className='os-iframe' src={bite_viz_dashboard}></iframe>
      </div>
    </ModuleHeaderLayout>
  );
};

export default BiteViz;
